import { IMaterialDetail } from '@/interfaces/doccen-lib/contentManagement.interface';
import { AxiosError } from 'axios';
import {
  DocumentFile,
  DocumentFileSkeleton,
} from 'design-system/components/DoccenLibrary/DocumentFile';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { UseInfiniteQueryResult } from 'react-query';
import { twMerge } from 'tailwind-merge';

const DisplayDocumentsGalleryDesktop = ({
  query,
  ...props
}: {
  query: UseInfiniteQueryResult<IMaterialDetail, AxiosError>;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  const {
    isLoading,
    data,
    hasNextPage,
    isFetching,
    fetchNextPage,
    isFetchingNextPage,
  } = query;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [inView, inView, hasNextPage, isFetching, fetchNextPage]);

  return (
    <>
      {isLoading ? (
        <div
          {...props}
          className={twMerge(
            'grid lg:grid-cols-4 lg:gap-8 xl:grid-cols-4 2xl:grid-cols-6',
            'justify-center',
            props.className
          )}
        >
          {new Array(6).fill(0).map((item, index) => (
            <DocumentFileSkeleton
              key={index}
              gridView
              type="1"
              className="w-auto"
            />
          ))}
        </div>
      ) : (
        <div
          {...props}
          className={twMerge(
            'grid lg:grid-cols-4 lg:gap-8 xl:grid-cols-4 2xl:grid-cols-6',
            (data?.pages.length || 0) >= 6 && 'justify-center',
            props.className
          )}
        >
          {data?.pages.map((item, index) => (
            <DocumentFile
              documentId={item.id}
              key={index}
              gridView
              type="1"
              title={item.name}
              thumbnail={item.thumbnailUrl}
              author={{
                userId: item.owner.id,
                name: item.owner.name,
                title: item.owner.academicRank,
              }}
              price={0}
              fileType={item.metadata.extension}
              className="h-full w-auto"
            />
          ))}

          {isFetchingNextPage ? (
            new Array(6)
              .fill(0)
              .map((item, index) => (
                <DocumentFileSkeleton
                  key={index}
                  gridView
                  type="1"
                  className="w-auto"
                />
              ))
          ) : (
            <div ref={hasNextPage ? ref : undefined}></div>
          )}
        </div>
      )}
    </>
  );
};

export default DisplayDocumentsGalleryDesktop;
